import gql from "graphql-tag"

const socialLinks = gql`
  fragment SocialLinks on SocialLinks {
    blueSky
    createdAt
    facebook
    id
    instagram
    reddit
    threads
    twitterX
    updatedAt
    website
    youtube
  }
`

export default socialLinks
